module.exports = __webpack_public_path__ + "static/media/Star.501d97ac.svg";